import React from 'react';
import palette from '../../color-palette';

interface MainsProps {
  darkMode: boolean;
}
const Mains = ({ darkMode, ...props }: MainsProps) => {
  const {
    primary: { main },
    common: { white },
  } = palette;

  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.88 19.68c-.04-.11-.1-.24-.14-.38-.08-.3-.15-.6-.25-.89-.1-.35-.2-.72-.35-1.05-.16-.37-.24-.76-.34-1.15-.07-.32-.18-.62-.27-.93-.07-.23-.09-.48-.13-.72-.04-.2-.07-.39-.16-.57a4.61 4.61 0 0 1-.29-.9c-.05-.24-.12-.48-.18-.71 0-.03-.04-.04-.08-.07l-.26.17c-.05.43-.11.82-.35 1.16l-.34-.07c.08-.31.04-.63.22-.9.01-.15-.02-.3.14-.45.4-.18.81-.42 1.27-.58.25-.09.49-.2.72-.33.15-.1.3-.19.48-.22.03 0 .05-.02.07-.03l1.55-.8c.19-.1.33-.24.4-.46.06-.17.17-.32.24-.49.2-.46.39-.92.57-1.39.1-.24.18-.5.28-.73l.08-.13c.14.02.14.02.25.13v.28c-.24.37-.33.82-.5 1.24-.1.29-.15.59-.3.86-.02.02-.02.05-.02.08-.05.25-.13.49-.32.72-.24.08-.47.27-.77.3-.08.02-.16.09-.25.12l-1.04.53-.13.08.33.6.12.23c.1.16.2.32.32.48.14.2.23.42.3.65.06.2.16.38.29.53.22.26.35.58.58.83.27.3.37.71.66 1 .06.06.08.16.12.24.1.26.3.47.44.7.11.2.22.4.31.6.1.19.19.39.27.58l.13.25c.27.44.59.86.76 1.35.3.43.45.93.69 1.4.13.25.23.52.3.8.03.19.1.36.17.54.16.44.17.9.15 1.35-.01.27-.04.55-.12.8-.07.2-.13.45-.37.55-.1.04-.15.14-.24.19-.19.12-.4.19-.62.17-.21-.01-.43.03-.63-.06-.24-.12-.5-.22-.7-.42-.19-.2-.4-.38-.6-.58a3.74 3.74 0 0 1-.59-.73c-.14-.25-.32-.48-.5-.72l-.06-.08-.5-1.05c-.15-.3-.28-.6-.4-.9l-.16-.4-.25-.62Zm-.45-8.07c-.59.16-1.26.44-1.41.6.06.26.1.52.17.79.05.18.05.38.21.51l.01.25.2.47c.13-.03.24-.05.33-.1.17-.07.33-.21.5-.24.32-.06.55-.3.86-.33.05-.01.1-.05.13-.07.06-.15-.01-.25-.07-.34-.14-.22-.29-.42-.42-.64l-.5-.9Z"
        fill={darkMode ? white : main}
      />
      <path
        d="M8 8.85a4.16 4.16 0 0 1-.22-3.96c.17-.34.42-.63.69-.9a4.5 4.5 0 0 1 1.05-.88c.91-.5 2.46-.37 3.43-.17 4.86.98 3.85 9.5-1.3 8.28-.9-.21-1.72-.69-2.5-1.2-.47-.3-.85-.7-1.14-1.17Z"
        stroke={darkMode ? white : main}
      />
      <path
        d="M11.35 7.24a.45.45 0 0 1-.02-.42.37.37 0 0 1 .07-.1.54.54 0 0 1 .11-.08c.1-.06.26-.04.37-.02.51.1.4 1-.14.87a1 1 0 0 1-.26-.12.46.46 0 0 1-.13-.13ZM10.67 5.37l.27-.16.13-.06c.02 0 .05-.01.06-.03.02-.01.01-.1 0-.12-.18-.01-.36.02-.53.06-.03 0-.06.02-.1.04a.41.41 0 0 0-.12.05h-.03c-.02 0-.02-.02-.02-.04.02-.1.01-.22.03-.33l.03-.3c0-.1.01-.18.03-.28l.01-.13.02-.18c0-.04.03-.07 0-.1-.05-.01-.12-.06-.17-.01a.83.83 0 0 1-.24.14l-.07.03a.34.34 0 0 1-.06.02L9.75 4c-.1.03-.2.08-.28.13-.09.06-.2.2-.19.3.01.04 0 .1.04.14.11-.04.21-.1.32-.15.09-.04.16-.1.26-.13.04 0 .1-.05.13-.05 0 0-.02.21-.07.38l-.03.24c-.01.1-.04.19-.05.23a6.5 6.5 0 0 0-.09.45c0 .06-.03.15-.02.2 0 .04.04.07.08.07l.09.03c.1 0 .18-.04.25-.1l.06-.04c.11-.1.23-.17.33-.26.03-.04.06-.06.1-.08Z"
        fill={darkMode ? white : main}
      />
    </svg>
  );
};

export default Mains;
